import React from 'react';

function SmmGrowthRoleSection() {
  const handleConnectClick = (e) => {
    e.preventDefault();
    const formEl = document.querySelector('.contact-section') || document.getElementById('contact-form');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="what-is-seo-section">
      <div className="container what-is-seo-container">
        {/* Left Column: Image */}
        <div className="what-is-seo-left">
          <div className="what-is-seo-img-wrapper">
            <img
              src="/assets/images/social-media/social-img5.jpeg"
              alt="SMM Service: Their Role In the Growth Of Your Brand"
              className="what-is-seo-img"
            />
          </div>
        </div>

        {/* Right Column: Title, Description, and Button */}
        <div className="what-is-seo-right">
          <h2 className="what-is-seo-title">
            <span className="what-is-seo-red-title">SMM Service:</span> Their Role In The Growth Of Your Brand
          </h2>

          <p className="what-is-seo-desc">
            Marketing is very different and technical nowadays. Now it is not limited to banners and billboards. Marketing needs effort and a proper plan for the best outcomes. Billboards hardly make an impact on the audience now. But the social media marketing platforms present great opportunities for targeted and result oriented outcomes.
            <br /><br />
            Our social media marketing company has a professional team that has worked on various social media strategies. Our company knows how to make a social media marketing campaign successful. Our valuable clients trust us for reliable social media marketing services.
            <br /><br />
            Choose Experts to get the best SMM strategy that brings you profitable outcomes.
          </p>

          <button className="btn-seo-primary" onClick={handleConnectClick}>
            Let's Get Connected
          </button>
        </div>
      </div>
    </section>
  );
}

export default SmmGrowthRoleSection;
